export default "__VITE_ASSET__Cbt$FV3n__"